// extracted by mini-css-extract-plugin
export default {"container":"qr-codes-explanation-modal_container__ccT8E","bulletPoints":"qr-codes-explanation-modal_bulletPoints__64ojk"};